import { useSelector } from 'react-redux'
import { RaytebRequests } from '../../../_services'
import useFetch from '../../../_services/fetch'
import { PrescriptionViewModel } from '../../../models/ViewModels/PrescriptionViewModel'
import { Button, Icon, Table } from '../../../share/Elements'
import React, { useEffect, useState } from 'react'
import { ReducerType } from '../../../storeManager/ReducerType'
import { LoginInterface } from '../../../Interfaces/LoginInterface'
import { LoadingFit } from '../../../share/Components'
function PrescriptionHistory({ patientCode }) {
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  )
  const prescriptionNow = useSelector<ReducerType, PrescriptionViewModel>(
    (state) => state.reducerPrescription
  )
  const [list, setList] = useState<Array<PrescriptionViewModel>>([])
  const [number, setNumber] = useState<number>(1)
  const center = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter
  )
  const getList = useFetch<
    Array<PrescriptionViewModel>,
    unknown,
    ListPrescriptionInputModel
  >({
    request: RaytebRequests.Prescription_GetAll_Get({
      token: user.token,
      centerId: center.id,
    }),
    onSuccess(data) {
      setList([...list, ...data])
    },
  })
  useEffect(() => {
    getList.reFetch(null, {
      pageNumber: 1,
      pageSize: 5,
      patientCode: patientCode,
    })
  }, [patientCode])
  useEffect(() => {
    const index = list.findIndex((n) => n.id === prescriptionNow.id)
    var copyList = [...list]
    copyList[index!] = prescriptionNow
    setList(copyList)
  }, [prescriptionNow])
  return (
    <>
      <div className='px-2 relative'>
        <LoadingFit isLoading={getList.isLoading} />

        <Table className='mt-2'>
          <thead className='text-xs'>
            <tr>
              <th>تاریخ</th>
              <th>کد پیگیری</th>
              <th>چاپ</th>
            </tr>
          </thead>
          <tbody className='text-xs'>
            {list?.map((n, i) => (
              <tr className='[&>*]:h-10' key={i}>
                <td className='text-center'>
                  {n.date ? new Date(n.date).toShamsi() : false}
                </td>
                <td className='text-center'>{n.trackingCode}</td>
                <td className='text-center'>
                  <Icon
                    disabled={!n.trackingCode}
                    icon='rayteb-printer'
                    className='text-xl text-primary'
                    onClick={() => {
                      window.open(
                        `${window.env['APP_Domain']}/api/DoctorProfile/Prescription/Print?ticketId=${n.ticketId}`
                      )
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <div className='flex justify-center items-center py-2'>
          <Button
            onClick={() => {
              const nextNubmer = number + 1
              getList.reFetch(null, {
                pageNumber: nextNubmer,
                pageSize: 5,
                patientCode: patientCode,
              })
              setNumber(nextNubmer)
            }}
            className='text-sm rounded-md bg-white text-primary w-44 py-1'
          >
            نمایش بیشتر
          </Button>
        </div>
      </div>
    </>
  )
}
export default React.memo(PrescriptionHistory)
